import { httpClient2 } from "modules/core/utils/httpClient2";
import { httpClient } from "../../core/utils/httpClient";

import { IUser, UserFeatureModuleKey } from "../types/entities";

export const fetchAuthUser = async (): Promise<IUser> => {
  const response = await httpClient.get<IUser>("/profiles");

  return response.data;
};

export const setOldExperimentsKanbanPreference = async (): Promise<void> => {
  await httpClient.put("/users/prefer_old_experiments");
};

export const createUserFeatureAccess = async ({
  featureKey
}: {
  featureKey: UserFeatureModuleKey;
}): Promise<void> => {
  const response = await httpClient2.post("/feature_module_accesses/user", {
    key: featureKey
  });

  return response.data;
};

export const deleteUserFeatureAccess = async ({
  featureKey
}: {
  featureKey: UserFeatureModuleKey;
}): Promise<void> => {
  const response = await httpClient2.delete("/feature_module_accesses/user", {
    params: { key: featureKey }
  });

  return response.data;
};
